import axios from 'axios'
import { ElMessage } from 'element-plus'
import 'element-plus/theme-chalk/src/notification.scss'
import store from '../store'
import router from '../router'

axios.defaults.baseURL='https://qa.www.fapiaomanagement.cn'
axios.defaults.timeout=1000*60*6;

//请求拦截器
axios.interceptors.request.use(function(config){
    if (config.url === 'logger/action/add') {
        return config
    }
    if (store.state.logged_in) {
        config.headers.Authorization = 'Bearer ' + store.state.logged_in
    }
    return config
},function(error){
    ElMessage({
        showClose:true,
        message:'网络错误，与服务器无法通信',
        type: 'error',
        duration: 5000,
        grouping: true
    });
    return Promise.reject(error)
})


//响应拦截器
axios.interceptors.response.use(function(response){
    if(response.status>=200 && response.status<400){
        if(response.data instanceof Blob){
        }else if (response.data.code == 0) {
        } else if(response.data.code >= 2000 && response.data.code < 3000) {
            ElMessage({
                showClose:true,
                message:response.data.message,
                type: 'error',
                duration: 5000,
                grouping: true
            });
        } else if(response.data.code >= 100000 && response.data.code < 200000) {
            ElMessage({
                showClose:true,
                message:response.data.message,
                type: 'info',
                duration: 5000,
                grouping: true
            });
	} else{
            ElMessage({
                showClose:true,
                message:response.data.message + '(' + response.data.code + ')',
                type: 'error',
                duration: 5000,
                grouping: true
            });
            if(response.data.code >= 1 && response.data.code <= 5){
                router.push({name:"login"})
                store.commit('setLocationnow','')
                store.commit('setBasetagslist',{})
                store.commit('setBaseselectedtag','')
                store.commit('setMenuclicknow','')
                store.commit('setLoggedIn','')
                clearInterval(store.state.intervalid)
            }
        }
    }else{
        ElMessage({
            showClose:true,
            message:'HTTP' + response.status + ' 未知错误',
            type: 'error',
            duration: 5000
        });
    }
    return response
},function(error){
    if(error.response.status == 401){
        ElMessage({
            showClose:true,
            message:'需要重新登录',
            type: 'error',
            duration: 5000,
            grouping: true
        });
        router.push({name:"login"})
        store.commit('setLocationnow','')
        store.commit('setBasetagslist',{})
        store.commit('setBaseselectedtag','')
        store.commit('setMenuclicknow','')
        store.commit('setLoggedIn','')
        clearInterval(store.state.intervalid)
    }else{
        window.loading.close()
        ElMessage({
            showClose:true,
            message:'网络错误，请稍后重试',
            type: 'error',
            duration: 5000,
            grouping: true
        });
    }
    return Promise.reject(error)
})




export default axios;
